import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry, Sentry } from "./lib/sentry";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

import { ErrorBoundaryFallback } from "./components/ErrorBoundaryFallback";

initSentry();

// The app rendered successfully, so any earlier chunk-load reload (see
// ErrorBoundaryFallback) worked. Clear the guard so a future deploy can
// still trigger one reload attempt of its own.
try {
  sessionStorage.removeItem("anchorstay-chunk-reload-attempted");
} catch {
  // sessionStorage can throw in some privacy modes -- non-critical, ignore.
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => <ErrorBoundaryFallback error={error as Error} resetError={resetError} />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
